import { defineMessages } from 'react-intl'

export default defineMessages({
  backText: {
    id: 'components.Breadcrumbs.back.text',
    defaultMessage: '{link}',
  },
  backLinkText: {
    id: 'components.Breadcrumbs.back.linkText',
    defaultMessage: 'Go back',
  },
})
